import React, { useCallback, useMemo, useState } from 'react';
import FilterPanel from '@components/FilterPanel';
import { translate } from '@utils/i18n';
import { TabView } from '@ui/molecules/TabView';
import useFilters from '../hooks/useFilters';
import { TABS } from '../constants';
import OverviewTab from './OverviewTab';
import TechPerformanceTab from './TechPerformanceTab';
import ComingSoonPlaceholder from './ComingSoonPlaceholder';
const namespace = 'features.dashboards.inspection_assistant_insights_v2';
const VISIBLE_TABS = ['overview', 'tech_performance'];
function getInitialTab() {
    const hash = window.location.hash.replace('#', '');
    if (VISIBLE_TABS.includes(hash))
        return hash;
    return 'overview';
}
function InspectionAssistantInsightsV2Dashboard({ ipaScorecard = false }) {
    const [activeTab, setActiveTab] = useState(getInitialTab);
    const { filters, currentFilters, onResetFilters, onResetCache } = useFilters();
    const handleTabChange = useCallback((tabId) => {
        setActiveTab(tabId);
        window.location.hash = tabId;
    }, []);
    const visibleTabs = useMemo(() => TABS.filter((tab) => VISIBLE_TABS.includes(tab.id)).map((tab) => ({
        id: tab.id,
        label: translate(tab.labelKey, { namespace })
    })), []);
    return (React.createElement(React.Fragment, null,
        React.createElement(FilterPanel, { onResetFilters: onResetFilters, onResetCache: onResetCache, filters: filters }),
        React.createElement("div", { className: "ia-insights-v2" },
            React.createElement(TabView, { tabs: visibleTabs, activeTabId: activeTab, onChange: handleTabChange },
                activeTab === 'overview' && React.createElement(OverviewTab, { filters: currentFilters }),
                activeTab === 'tech_performance' && React.createElement(TechPerformanceTab, { filters: currentFilters, ipaScorecard: ipaScorecard }),
                activeTab !== 'overview' && activeTab !== 'tech_performance' && React.createElement(ComingSoonPlaceholder, null)))));
}
export default InspectionAssistantInsightsV2Dashboard;
